"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpression = function (e) {
    return typeof e === 'object' &&
        e.type &&
        [
            'Compound',
            'Identifier',
            'MemberExpression',
            'Literal',
            'ThisExpression',
            'CallExpression',
            'UnaryExpression',
            'BinaryExpression',
            'LogicalExpression',
            'ConditionalExpression',
            'ArrayExpression',
        ].includes(e.type);
};
exports.isArrayExpression = function (e) {
    return e.type === 'ArrayExpression';
};
exports.isBinaryExpression = function (e) {
    return e.type === 'BinaryExpression';
};
exports.isCallExpression = function (e) {
    return e.type === 'CallExpression';
};
exports.isCompound = function (e) {
    return e.type === 'Compound';
};
exports.isConditionalExpression = function (e) { return e.type === 'ConditionalExpression'; };
exports.isIdentifier = function (e) {
    return e.type === 'Identifier';
};
exports.isLiteral = function (e) { return e.type === 'Literal'; };
exports.isLogicalExpression = function (e) {
    return e.type === 'LogicalExpression';
};
exports.isMemberExpression = function (e) {
    return e.type === 'MemberExpression';
};
exports.isThisExpression = function (e) {
    return e.type === 'ThisExpression';
};
exports.isUnaryExpression = function (e) {
    return e.type === 'UnaryExpression';
};
exports.traverse = function (ast, visitor) {
    return Object.keys(ast).reduce(function (acc, prop) {
        var _a;
        var child = acc[prop];
        if (exports.isExpression(child)) {
            return __assign({}, acc, (_a = {}, _a[prop] = visitor(child, acc), _a));
        }
        return acc;
    }, ast);
};
//# sourceMappingURL=traverse.js.map